import { Endpoint } from '../endpoint';
import { CommissionGroupRequest, CommissionOverrideResponse, CommissionOverrideId } from '@business/entities/commission_group';

export function fetchCommissionOverrides() {
  return Endpoint.get<CommissionOverrideResponse[]>(`@gc/commission-override`);
}

export function fetchCommissionOverride(id: CommissionOverrideId) {
  return Endpoint.get<CommissionOverrideResponse>(`@gc/commission-override/company/${id}`);
}

export function createCommissionOverride(data: Partial<CommissionOverrideResponse>) {
  return Endpoint.post<CommissionOverrideResponse>(`@gc/commission-override/create`, { data });
}

export function updateCommissionOverride(id: CommissionOverrideId, data: Partial<CommissionGroupRequest>) {
  return Endpoint.patch<CommissionOverrideResponse>(`@gc/commission-override/${id}`, { data });
}

export function deleteCommissionOverride(id: CommissionOverrideId) {
  return Endpoint.delete<void>(`@gc/commission-override/${id}`);
}
